import createReducer from '../utils/createReducer';
import actions from '../actions/landingPage';
import leadsFormMapper from '../utils/leadsFormMapper';

const initialState = {};

const actionHandlers = {
    [actions.SET_CARD_DETAILS](state, {payload}) {
        return {
            ...state,
            cardQuestionId: payload.cardQuestionId
        };
    },

    [actions.SET_ACCOUNT_STATUS](state, {payload}) {
        return {
            ...state,
            accountStatus: payload.status
        };
    },

    [actions.GET_LEADS_FORM_SITE](state, {payload}) {
        return {
            ...state,
            leadsFormSite: leadsFormMapper(payload.siteName)
        };
    },

    [actions.SET_LANGUAGE](state, {payload}) {
        return {
            ...state,
            language: payload.language
        };
    }
};

export default createReducer(actionHandlers, initialState);
